export const addMetadataObject = (dataArray, metadata) => {
  if (!dataArray || dataArray.length === 0) {
    return [];
  }
  const keys = Object.keys(dataArray[0]);
  const configObject = keys.reduce((accumulator, currentKey) => {
    accumulator[currentKey] = {
      type: metadata[currentKey]?.type || 'string',
      caption: metadata[currentKey]?.caption || currentKey,
    };
    return accumulator;
  }, {});
  return [configObject, ...dataArray];
};

const TOOLBAR_CONFIGURATION = (handleSave, handleReset, intl) => [
  /*   {
    id: 'save-configuration',
    title: 'Salva',
    handler: handleSave,
    icon: '<svg width="36" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M20.71,9.29l-6-6a1,1,0,0,0-.32-.21A1.09,1.09,0,0,0,14,3H6A3,3,0,0,0,3,6V18a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V10A1,1,0,0,0,20.71,9.29ZM9,5h4V7H9Zm6,14H9V16a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1Zm4-1a1,1,0,0,1-1,1H17V16a3,3,0,0,0-3-3H10a3,3,0,0,0-3,3v3H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H7V8A1,1,0,0,0,8,9h6a1,1,0,0,0,1-1V6.41l4,4Z"/></svg>',
  }, */
  {
    id: 'reset-configuration',
    title: intl?.messages?.RESET ?? 'Reset',
    handler: handleReset,
    rightGroup: true,
    icon: '<svg width="36" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 16c1.671 0 3-1.331 3-3s-1.329-3-3-3-3 1.331-3 3 1.329 3 3 3z"/><path d="M20.817 11.186a8.94 8.94 0 0 0-1.355-3.219 9.053 9.053 0 0 0-2.43-2.43 8.95 8.95 0 0 0-3.219-1.355 9.028 9.028 0 0 0-1.838-.18V2L8 5l3.975 3V6.002c.484-.002.968.044 1.435.14a6.961 6.961 0 0 1 2.502 1.053 7.005 7.005 0 0 1 1.892 1.892A6.967 6.967 0 0 1 19 13a7.032 7.032 0 0 1-.55 2.725 7.11 7.11 0 0 1-.644 1.188 7.2 7.2 0 0 1-.858 1.039 7.028 7.028 0 0 1-3.536 1.907 7.13 7.13 0 0 1-2.822 0 6.961 6.961 0 0 1-2.503-1.054 7.002 7.002 0 0 1-1.89-1.89A6.996 6.996 0 0 1 5 13H3a9.02 9.02 0 0 0 1.539 5.034 9.096 9.096 0 0 0 2.428 2.428A8.95 8.95 0 0 0 12 22a9.09 9.09 0 0 0 1.814-.183 9.014 9.014 0 0 0 3.218-1.355 8.886 8.886 0 0 0 1.331-1.099 9.228 9.228 0 0 0 1.1-1.332A8.952 8.952 0 0 0 21 13a9.09 9.09 0 0 0-.183-1.814z"/></svg>',
  },

  {
    id: 'wdr-tab-export',
    menuIds: ['wdr-tab-export-excel'],
    rightGroup: true,
  },
  {
    id: 'wdr-tab-fullscreen',
    rightGroup: true,
  },
  { id: 'wdr-tab-format' },
  { id: 'wdr-tab-fields' },
];

export const getCustomizedToolbar = (
  toolbar,
  handleSave,
  handleReset,
  intl
) => {
  if (!toolbar || typeof toolbar.getTabs !== 'function') return;
  const getDefaultTabs = toolbar.getTabs.bind(toolbar);

  toolbar.getTabs = () =>
    TOOLBAR_CONFIGURATION(handleSave, handleReset, intl)
      .map((config) => {
        const tabs = getDefaultTabs();
        let foundTab = tabs.find((tab) => config.id === tab.id);
        if (!foundTab && config.id.startsWith('wdr-tab-')) {
          return null;
        }
        foundTab = {
          ...foundTab,
          menu: foundTab?.menu?.filter(
            (x) => !config?.menuIds || config?.menuIds?.find((c) => c === x.id)
          ),
        };
        return {
          ...foundTab, //spreads all the properties of the found tab option
          ...config, //overwrite some properties on the found tab
        };
      })
      .filter(Boolean);
};
